import * as React from 'react';
import { Field, reduxForm } from 'redux-form';
import { AgreementPageWithFormProps } from '../ClientAgreement';
import {
  FullWidthTextField,
  RadioField,
  SelectField
} from '../../../shared/Forms/FullWidthForm/fullWidthFormComponents';
import { fiveDaysFuture, required } from '../../../shared/Forms/validations';
import { connect } from 'react-redux';
import ContentContainer, { formSelector } from '../ContentContainer/Content';
import agreementStyles from '../ClientAgreement.module.css';
import accountTypeMap from './accountTypeMap';
import stateMap from '../../PersonalDetailsForm/stateMap';
import draftScheduleOptions from './draftScheduleOptions';
import cftLogo from '../cft_logo.jpg';
import { formatDollar } from '../../../shared/Forms/formats';

const AgreementPage9 = (props: AgreementPageWithFormProps) => (
  <ContentContainer {...props} requiredSignatures="clientAndInitial" currentPage={9}>
    <div className={agreementStyles.contentHeader}>
      <img src={cftLogo} className={agreementStyles.cftLogo} alt="CFT Logo" />
      <br />
      <br />
      ELECTRONIC FUNDS
      <br />
      <br />
    </div>
    <div className={agreementStyles.noScrollContainer}>
      <b>Electronic Funds Transfer Authorization</b>
      <br /> (1) To fund your SPA, you authorize Finxera to initiate automated clearing house debit
      transfers from the designated bank account (your “Primary Account”) to your SPA in the amounts
      and on the dates specified by you or your DSP from time to time. To effect your Plan, you
      further authorize Finxera to initiate automated clearing house debit transfers from your SPA
      to your creditors in the amounts and on the dates directed by you, or as transmitted by your
      DSP from time to time. Finally, you authorize Finxera to deduct from your SPA fees due Finxera
      as they accrue and become payable and to credit to your SPA or the Primary Account any credits
      due to you. You represent that you own the Primary Account and are authorized to provide this
      instruction. You agree to maintain sufficient funds in the Primary Account to cover each
      authorized transfer and understand that Finxera may charge you a fee if there are insufficient
      available funds (see Fee Schedule). The financial institution holding the Primary Account also
      may impose a charge for insufficient funds. (2) You will contact your DSP if you decide to
      designate another Primary Account or wish to change the amount or the date for transfers to or
      from your SPA. Notice of any change affecting this authorization (including termination) must
      be provided to Finxera in such a manner and sufficiently in advance to allow Finxera and any
      affected financial institution a reasonable opportunity to act, no later than three (3)
      business days beforehand. (3) This authorization shall remain in effect until you give notice
      of termination by contacting Finxera Customer Service at P.O. Box 940, San Jose, CA 95113, or
      at 1-888-348-4543. (4) You acknowledge that your transactions must comply with the provisions
      of U.S. law. (5) Finxera may terminate this processing service, with or without cause, at any
      time by sending notice to Applicant’s last known address and/or DSP, specifying the effective
      date of termination, which may be immediate. (6) You understand that you have the right to
      close your SPA at any time and receive your money back in the manner described in Paragraph 1
      on the following page of this Account Agreement.
    </div>
    <div style={{ margin: '20px' }}>
      <div className={agreementStyles.contentHeader}>PRIMARY ACCOUNT INFORMATION</div>
      <Field
        name="bankName"
        type="text"
        component={FullWidthTextField}
        label="Bank Name"
        validate={required}
      />
      <Field
        name="routingNumber"
        type="text"
        component={FullWidthTextField}
        label="Routing Number"
        validate={required}
      />
      <Field
        name="accountNumber"
        type="text"
        component={FullWidthTextField}
        label="Account Number"
        validate={required}
      />
      <Field
        name="accountType"
        type="text"
        dataMap={accountTypeMap}
        component={SelectField}
        label="Account Type"
        validate={required}
      />
    </div>
    <div style={{ margin: '20px' }}>
      <div className={agreementStyles.contentHeader}>ACCOUNT HOLDER INFORMATION</div>
      <Field
        name="accountHolderName"
        type="text"
        component={FullWidthTextField}
        label="Name"
        validate={required}
      />
      <Field
        name="accountHolderStreetAddress"
        type="text"
        component={FullWidthTextField}
        label="Street Address"
        validate={required}
      />
      <Field
        name="accountHolderCity"
        type="text"
        component={FullWidthTextField}
        label="City"
        validate={required}
      />
      <Field
        name="accountHolderState"
        type="text"
        dataMap={stateMap}
        component={SelectField}
        label="State"
        validate={required}
      />
      <Field
        name="accountHolderZip"
        type="number"
        component={FullWidthTextField}
        label="Zip Code"
        validate={required}
      />
    </div>
    <div style={{ margin: '20px' }}>
      <div className={agreementStyles.contentHeader}>
        DRAFT SCHEDULE
      </div>
      <Field
        name="draftOption"
        component={RadioField}
        options={draftScheduleOptions}
        validate={required}
        disabled={true}
      />
      {props.draftOption && (
        <>
          <Field
            disabled
            name="initialDraftAmount"
            type="text"
            fieldFormat="dollar"
            format={formatDollar}
            component={FullWidthTextField}
            label="Initial Draft Amount"
            validate={required}
          />
          <Field
            disabled
            name="initialDraftDate"
            type="date"
            component={FullWidthTextField}
            label="Initial Draft(s) to be executed on or after"
            validate={[required]}
          />
          <Field
            disabled
            name="draftAmount"
            type="text"
            fieldFormat="dollar"
            format={formatDollar}
            component={FullWidthTextField}
            label="Draft Amount"
            validate={required}
          />
          <Field
            disabled
            name="recurringDraftDate"
            type="date"
            component={FullWidthTextField}
            label="Recurring Draft Schedule on or after"
            validate={[required]}
          />
        </>
      )}
    </div>
  </ContentContainer>
);

const form = reduxForm({
  form: 'clientAgreement',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true
})(AgreementPage9 as any);

export default connect(state => ({
  name: formSelector(state, 'name'),
  draftOption: formSelector(state, 'draftOption'),
  existingInitial: formSelector(state, 'clientInitials'),
  existingSignature: formSelector(state, 'clientSignature')
}))(form) as any;
